import Core from '../core'

class Compare extends Core {

  constructor(options = {}) {
    super('compare', options)
    this.initEvents()
  }

  initEvents() {
    super.initEvents()

    const categoryFilter = document.getElementById('category-filter')
    if (categoryFilter) {
      categoryFilter.addEventListener('change', this.updateTableByCategory)
    }

    this.tables.forEach(table => {
      table.addEventListener('click', this.tableClickHandler)
    })
  }

  tableClickHandler = async e => {
    if (e.target.closest('[data-action="clear"]')) {
      e.preventDefault()

      const button = e.target.closest('[data-action="clear"]')

      this.emit('loading', true, button)

      try {
        await this.clearCompare()
      } catch (e) {
        super.onError(e)
      } finally {
        this.emit('loading', false, button)
        this.emit('updated')
      }
    }

    if (e.target.closest(this.options.selectors.remove)) {
      e.preventDefault()

      const button = e.target.closest(this.options.selectors.remove)
      const productID = parseInt(button.dataset.id)

      this.emit('loading', true, button)

      try {
        await this.deleteProduct(productID)
      } catch (e) {
        this.onError(e)
      } finally {
        this.emit('loading', false, button)
        this.emit('updated')
      }
    }

    if (e.target.closest(this.options.selectors.collapse)) {
      e.preventDefault()

      e.target.closest(this.options.selectors.collapse)
        .parentNode
        .classList
        .toggle(this.options.classes.collapse)
    }
  }

  clearCompare = async () => {
    const result = await this.rest.delete()

    if (result.ok) {
      this.store = result.data
      this.emit('cleared', result)
    } else {
      throw result
    }

    return result
  }

  updateTableByCategory = async e => {
    const selectedCategoryId = e.target.value

    this.emit('loading', true)

    try {
      if (selectedCategoryId === '') {
        // Если категория пуста, обновляем все таблицы
        this.updateTables()
      } else {
        // Фильтруем по выбранной категории
        const result = await this.rest.get(`table?category_id=${selectedCategoryId}`)
        this.tables.forEach(table => {
          table.innerHTML = result.data
        })
      }
    } catch (e) {
      this.onError(e)
    } finally {
      this.emit('loading', false)
    }
  }
}

export default Compare
